import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { CategoryParams, ProductParams } from 'models';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getMenuCategoryApi, getMenuProductByCategoryApi, getMenuSetApi } from 'redux/api';
import { menuAction } from 'redux/slices/menuSlice';

function* getMenuCategorySaga(action: PayloadAction<CategoryParams>) {
  const { shopId, type_get, appName } = action.payload;

  try {
    const res: AxiosResponse = yield call(getMenuCategoryApi, { shopId, type_get, appName });
    const { data } = res.data;
    yield put(menuAction.getMenuCategoryListSuccess(data));
  } catch (error) {}
}
function* getMenuProductSaga(action: PayloadAction<ProductParams>) {
  const { shopId, type_get, cid_category, page, per_page, sort_type, key, appName } =
    action.payload;

  try {
    const res: AxiosResponse = yield call(getMenuProductByCategoryApi, {
      shopId,
      type_get,
      cid_category,
      page,
      per_page,
      sort_type,
      key,
      appName,
    });
    const { data } = res.data;
    yield put(menuAction.getMenuProductListSuccess(data.data));
  } catch (error) {}
}
function* getMenuSetSaga(action: PayloadAction<{ shop_id: number; appName: string }>) {
  const { shop_id, appName } = action.payload;

  try {
    const res: AxiosResponse = yield call(getMenuSetApi, {
      shop_id,
      appName,
    });
    const { data } = res;
    yield put(menuAction.getMenuSetListSuccess(data));
  } catch (error) {}
}
export default function* menuSaga() {
  yield takeLatest(menuAction.getMenuCategoryList.type, getMenuCategorySaga);
  yield takeLatest(menuAction.getMenuProductList.type, getMenuProductSaga);
  yield takeLatest(menuAction.getMenuSetList.type, getMenuSetSaga);
}
